import { getItem } from "~/es6/localstorage";
import { IReportSaveData, IReportState } from "./interfaces";
import { LS_NAME } from "./constants";
import { IUserFeedbackItem } from "~/report/interfaces";

export function getId(source: string, id: number) {
	return `${source}_${id}`;
}

export function loadLocalChanges(): IReportState["data"] {
	try {
		const data = getItem(LS_NAME);

		if (data) {
			const json = JSON.parse(data);

			return json;
		}
	} catch (exc) {
		//
	}

	return {};
}

export function transformBeToState(item: IUserFeedbackItem) {
	const output: IReportSaveData = {
		date: item.created,
	};
	const allKeys = Object.keys(item.user_data);

	for (const key of allKeys) {
		switch (key) {
			case "message":
				output.note = item.user_data.message;
				break;

			case "location":
				output.location = item.user_data.location.address;
				break;

			default:
				output[key] = item.user_data[key];
		}
	}

	if (item.attachment_types.includes("photo")) {
		output.photos = true;
	}

	if (item.attachment_types.includes("opening")) {
		output.openingPhotos = true;
	}

	return output;
}

export function checkDeleteDate(date: string, afterMinutes: number) {
	const dateObj = new Date(date);

	return Date.now() > dateObj.getTime() + afterMinutes;
}
